<div class="col-md-12">
  <p class="round-border bg-enelx-light-purple padding-md loader-message">
      <i class="fa fa-spinner fa-spin fa-lg"></i>&nbsp; <strong>Loading contents, please, wait...</strong>
  </p>
</div>